var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52.497,
    height: 62.44,
    viewBox: "0 0 52.497 62.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3356",
    "data-name": "Trazado 3356",
    d: "M26.431,0a1.388,1.388,0,0,0-.177.013h-.008a1.373,1.373,0,0,0-.608.253A90.145,90.145,0,0,1,.926,13.242a1.374,1.374,0,0,0-.914,1.269c-.2,14.419,2.352,25.246,7.811,33.1,4.4,6.341,10.036,10.024,15.483,13.586l1.559,1.023a1.366,1.366,0,0,0,.74.217,1.381,1.381,0,0,0,.716-.2l1.584-.977c5.543-3.406,11.275-6.93,15.856-13.143,5.677-7.7,8.535-18.454,8.737-32.873v-.032a1.374,1.374,0,0,0-.88-1.262A90.124,90.124,0,0,1,27.275.285,1.353,1.353,0,0,0,26.459,0Z",
    transform: "translate(0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.004,
    y1: 1,
    x2: 0.008,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b8e47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#26a066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21b78b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_639",
    "data-name": "Grupo 639",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_636",
    "data-name": "Grupo 636",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_635",
    "data-name": "Grupo 635",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_112",
    "data-name": "Rect\\xE1ngulo 112",
    width: 52.689,
    height: 62.44,
    transform: "translate(-0.192 0)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_638",
    "data-name": "Grupo 638",
    transform: "translate(1 2.061)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_640",
    "data-name": "Grupo 640",
    transform: "translate(13.611 13.139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3357",
    "data-name": "Trazado 3357",
    d: "M45.346,54.721a7.651,7.651,0,0,1,1.291-4.074A9.939,9.939,0,0,1,50.4,47.229a11.852,11.852,0,0,1,5.777-1.354A12.338,12.338,0,0,1,61.6,47.007a8.788,8.788,0,0,1,3.629,3.079,7.553,7.553,0,0,1,1.28,4.232,6.545,6.545,0,0,1-.73,3.153,9.658,9.658,0,0,1-1.735,2.338q-1.005.984-3.608,3.312a14.667,14.667,0,0,0-1.153,1.153,4.674,4.674,0,0,0-.645.91,4.464,4.464,0,0,0-.328.825q-.116.413-.349,1.45a2.355,2.355,0,0,1-2.518,2.2,2.574,2.574,0,0,1-1.852-.719,2.825,2.825,0,0,1-.751-2.137,7.5,7.5,0,0,1,2.01-5.364A33.435,33.435,0,0,1,57.3,59.1q1.354-1.185,1.957-1.788a6.068,6.068,0,0,0,1.016-1.344,3.25,3.25,0,0,0,.413-1.608A3.741,3.741,0,0,0,59.429,51.5a4.6,4.6,0,0,0-3.248-1.164,4.493,4.493,0,0,0-3.428,1.175,9.363,9.363,0,0,0-1.862,3.46q-.72,2.391-2.73,2.391a2.682,2.682,0,0,1-2-.836,2.555,2.555,0,0,1-.815-1.809M55.673,77.914a3.331,3.331,0,0,1-2.254-.836,2.931,2.931,0,0,1-.963-2.338,3.012,3.012,0,0,1,.931-2.243,3.145,3.145,0,0,1,2.285-.91,3.108,3.108,0,0,1,3.153,3.153,2.954,2.954,0,0,1-.952,2.328,3.214,3.214,0,0,1-2.2.846",
    transform: "translate(-45.346 -45.875)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamAvailable);
export default __webpack_public_path__ + "static/media/team-available.99fe7eea7f4d38e6d8bcb3b18f7b6e43.svg";
export { ForwardRef as ReactComponent };